<script setup>
import { useI18n } from 'vue-i18n';
import SliderField from '../../fields/SliderField.vue';
import VisibilityField from '../../fields/VisibilityField.vue';

defineProps({
  node: { type: Object, required: true },
  // Elemento do rodapé fica sempre visível (o servidor força): sem o campo.
  selection: { type: Object, default: null },
});
const emit = defineEmits(['update']);
const { t } = useI18n();
</script>

<template>
  <div data-props="spacer" class="flex flex-col gap-4">
    <SliderField
      :label="t('EMAIL_TEMPLATES.EDITOR.PROPS.HEIGHT')"
      :model-value="node.height"
      :min="4"
      :max="200"
      unit="px"
      @update:model-value="v => emit('update', { height: v }, 'height')"
    />
    <VisibilityField
      v-if="selection?.row?.role !== 'footer'"
      :model-value="node.style?.hide_on"
      @update:model-value="
        v => emit('update', { style: { hide_on: v } }, 'hide_on')
      "
    />
  </div>
</template>
